import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M8.25.946A3.138 3.138 0 0 0 6.353.29H0v16h6.353c.717 0 1.365.256 1.897.657V.946zM11.647.29c-.717 0-1.365.256-1.897.657v16a3.139 3.139 0 0 1 1.897-.657H18v-16h-6.353z" />
  </svg>
);

export default SvgComponent;
